import React, { useEffect, useState } from "react";

import "./Report.css";
import "../../Components/Commons/Commons.css";

import SidebarMenu from "../../Components/Sidebar/Sidebar";
import AntDTable from "../../Components/AntDTable/AntDTable";
import BtnExcel from "../../Components/Commons/Buttons/BtnExcel";
import dayjs from "dayjs";
import BtnDownloadTable from "../../Components/Commons/Buttons/BtnDownloadTable";
import { getDailyLogsReport } from "../../Components/Helpers/API/ReportsApi/ReportsApi";
import { getAllDoctors } from "../../Components/Helpers/API/DoctorApi/DoctorApi";

import { Row, Col } from "react-bootstrap";
import { DatePicker, Select } from "antd";
import { formatDate } from "../../Assets/Helpers/Common";
import {
  capitalizeFirstLetter,
  formatDateWithTime,
  formatPrice,
  getTodayDateISO,
} from "../../Components/Helpers/Utilities/Common";

const { RangePicker } = DatePicker;
const { Option } = Select;

function DailyLogs() {
  const [showLoader, setShowLoader] = useState(false);
  const [totalProfessionalFee, setTotalProfessionalFee] = useState("");
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [dateRange, setDateRange] = useState([
    dayjs(getTodayDateISO(), "YYYY-MM-DD"),
    dayjs(getTodayDateISO(), "YYYY-MM-DD"),
  ]);
  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const xlsxHeaders = [
    "CHECK-UP DATE",
    "PATIENT",
    "AGE",
    "PATIENT TYPE",
    "VISIT TYPE",
    "BIRTHDATE",
    "ADDRESS",
    "COVERAGE NAME",
    "CHIEF COMPLAINT",
    "DIAGNOSIS",
    "PHYSICIAN",
    "PHYSICIAN TYPE",
    "PROCEDURE",
    "FOLLOW-UP-ON",
  ];

    //Function for adding a custom footer in the table
  const customFooter = () => (
    <div className="row">
      <div className="" style={{ textAlign: "center" }}>
        Patient Count: {data?.length || 0}
      </div>
    </div>
  );

  //Function for handling the date range in the table
  const onDateChange = (date,dateString) => {
    setDateRange(dateString);
  };

  //Function for handling the doctor filter in the table
  const handleDoctorChange = (value) => {
    setSelectedDoctor(value);
  };

  //Function for getting pdf header
  const getPdfHeaderTitle = () => {
    if (dateRange[0] && dateRange[1]) {
      var from = formatDate(dateRange[0]);
      var to = formatDate(dateRange[1]);

      return from !== to ? `${from} - ${to}` : from;
    } else {
      return formatDate(getTodayDateISO());
    }
  };

  //Funcion get daily log report API
  async function _get() {
    setShowLoader(true);
    const res = await getDailyLogsReport({
      date_from: dateRange[0].$isDayjsObject ? getTodayDateISO() : dateRange[0],
      date_to: dateRange[1].$isDayjsObject ? getTodayDateISO() : dateRange[1],
      doctor_id: selectedDoctor !== null ? selectedDoctor : "",
    });
    if (res.data) {
      var _parsed = res.data.data.map((log) => {
        var pfMethod = (log.professional_fee_method || "").toLowerCase();

        let coverage_name = "";
        if (!["no pf", "gcash", "cash", ""].includes(pfMethod)) {
          if (pfMethod === "hmo") {
            coverage_name = capitalizeFirstLetter(log.hmo_type || "");
          } else {
            coverage_name = capitalizeFirstLetter(log.corporate_type || "");
          }
        }
        return {
          ...log,
          assessment_date: log.assessment_date
            ? formatDate(log.assessment_date)
            : "",
          patient_type: capitalizeFirstLetter(log.patient_type),
          visit_type: capitalizeFirstLetter(log.visit_type),
          birthdate: log.birthdate
            ? formatDate(log.birthdate)
            : "",
          physician_type: log?.physician_type?.toUpperCase(),
          professional_fee: log.professional_fee ? formatPrice(log.professional_fee) : "",
          professional_fee_method: capitalizeFirstLetter(log.professional_fee_method),
          followup_on: log.followup_on ? formatDate(log.followup_on) : "",
          coverage_name
        };
      });
      setData(_parsed);
      var _parsedExcel = res.data.data.map((log) => {
        var _parsedPfMethod = (log.professional_fee_method || "").toLowerCase();

        let _parsed_coverage_name = "";
        if (!["no pf", "gcash", "cash", ""].includes(_parsedPfMethod)) {
          if (_parsedPfMethod === "hmo") {
            _parsed_coverage_name = capitalizeFirstLetter(log.hmo_type || "");
          } else {
            _parsed_coverage_name = capitalizeFirstLetter(log.corporate_type || "");
          }
        }
        return {
          assessment_date: log.assessment_date
            ? formatDate(log.assessment_date)
            : "",
          formatted_patient_name: log.formatted_patient_name,
          age: log.age,
          patient_type: capitalizeFirstLetter(log.patient_type),
          visit_type: capitalizeFirstLetter(log.visit_type),
          birthdate: log.birthdate
            ? formatDate(log.birthdate)
            : "",
          address: log.address,
          sales_invoice_no: log.sales_invoice_no,
          professional_fee: log.professional_fee ? formatPrice(log.professional_fee) : "",
          professional_fee_method: capitalizeFirstLetter(log.professional_fee_method),
          coverage_name: _parsed_coverage_name,
          chief_complaint: log.chief_complaint,
          diagnosis: log.diagnosis,
          doctor_name: log.doctor_name,
          physician_type: log?.physician_type?.toUpperCase(),
          procedure: log.procedure,
          followup_on: log.followup_on ? formatDate(log.followup_on) : "",
        };
      });
      setExcelData(_parsedExcel);
      setTotalProfessionalFee(res.data.total_professional_fee);
    } else if (res.error) {
      setData([]);
      setTotalProfessionalFee("");
    }
    setShowLoader(false);
  }

  // Function for get all doctors API
  async function fetchAllDoctors() {
    const response = await getAllDoctors();
    if (response.data) {
      // setDoctors(response.data.data);
      const mappedDoctors = response.data.data.map((doctor) => ({
        label: doctor.doctor_name, 
        value: doctor.id,
        id: doctor.id,
        doctor_name: doctor.doctor_name
      }));
      setDoctors(mappedDoctors);
    } else {
      setDoctors([]);
    }
  }

  useEffect(() => {
    _get();
    fetchAllDoctors();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, selectedDoctor]);

  return (
    <div className="App">
      <SidebarMenu active={"Reports"} active_sub={"Daily Logs"} />
      <div className="col p-5 pt-4 scrollable-container">
        <div className="row pt-3">
          <div className="col font-big title-2 all-patient">
            Daily Logs
          </div>
          <div className="col-2 flex patient-manager">
            <BtnDownloadTable
              label={"Download PDF"}
              size={"sm"}
              data={{
                body: data,
                columns: [
                  { header: "CHECK-UP", dataKey: "assessment_date" },
                  { header: "PATIENT", dataKey: "formatted_patient_name" },
                  { header: "AGE", dataKey: "age" },
                  { header: "PATIENT TYPE", dataKey: "patient_type" },
                  { header: "VISIT TYPE", dataKey: "visit_type" },
                  { header: "BIRTHDATE", dataKey: "birthdate" },
                  { header: "ADDRESS", dataKey: "address" },
                  { header: "SALES INV. #", dataKey: "sales_invoice_no" },
                  { header: "PF FEE", dataKey: "professional_fee" },
                  { header: "PF METHOD", dataKey: "professional_fee_method" },
                  { header: "COVERAGE NAME", dataKey: "coverage_name" },
                  { header: "CHIEF COMPLAINT", dataKey: "chief_complaint" },
                  { header: "DIAGNOSIS", dataKey: "diagnosis" },
                  { header: "PHYSICIAN", dataKey: "doctor_name" },
                  { header: "PHYSICIAN TYPE", dataKey: "physician_type" },
                  { header: "PROCEDURE", dataKey: "procedure" },
                  { header: "FOLLOW-UP", dataKey: "followup_on" },
                ],
              }}
              fileName={`${getTodayDateISO()} Daily Logs Report.pdf`}
              pdfHeader={{
                title: `Daily Logs Report (${getPdfHeaderTitle()})`,
                content: `This report is generated on ${formatDateWithTime(
                  new Date()
                )}.`,
              }}
              pdfFooter={{
                content: `Patient Count: ${data?.length || 0}   Total PF Charged = Php ${formatPrice(totalProfessionalFee || "0")}`,
              }}
              orientation="landscape"
            />
          </div>
          <div className="col-2 fles patient-manager">
            <BtnExcel
              label={"Download Excel"}
              size={"sm"}
              excelData={excelData}
              xlsxHeaders={xlsxHeaders}
              fileName={"DailyLogsReport.xlsx"}
            />
          </div>
        </div>
        <Row>
          <Col sm={6}>
            <Row className="row justify-content-start">
              <Col className="pl-0 mb-3">
                <RangePicker
                  onChange={onDateChange}
                  defaultValue={dateRange}
                  format={`YYYY-MM-DD`}
                />
              </Col>
              <Col className="pl-0 mb-3">
                <Select
                  placeholder="Select Doctor"
                  onChange={handleDoctorChange}
                  value={selectedDoctor}
                  style={{width: 300}}
                  allowClear
                  options={doctors}
                  optionFilterProp="label"
                  showSearch
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="row justify-content-center">
          <div className="col-sm-12 all-table" id="antd-table-container">
            <AntDTable
              tableHeaders={[
                "CHECK-UP DATE",
                "PATIENT",
                "AGE",
                "PATIENT TYPE",
                "VISIT TYPE",
                "BIRTHDATE",
                "ADDRESS",
                "SALES INV. #",
                "PF FEE",
                "PF METHOD",
                "COVERAGE NAME",
                "CHIEF COMPLAINT",
                "DIAGNOSIS",
                "PHYSICIAN",
                "PHYSICIAN TYPE",
                "PROCEDURE",
                "FOLLOW-UP-ON",
              ]}
              headerSelector={[
                "assessment_date",
                "formatted_patient_name",
                "age",
                "patient_type",
                "visit_type",
                "birthdate",
                "address",
                "sales_invoice_no",
                "professional_fee",
                "professional_fee_method",
                "coverage_name",
                "chief_complaint",
                "diagnosis",
                "doctor_name",
                "physician_type",
                "procedure",
                "followup_on",
              ]}
              tableData={data}
              loading={showLoader}
              scroll={{ x: "max-content" }}
              customFooter={customFooter}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DailyLogs;